import { FormattedMessage } from 'react-intl'

import { StyledAlert } from './styled'

// The first check-in reminder started arriving on 3 September 2026 after four years of silence,
// so people need to be told the extra email is not a fault. The block expires on its own instead
// of relying on someone remembering to remove it.
const VISIBLE_UNTIL = new Date('2026-12-31T23:59:59')

const ReleaseNotice = () => {
  if (Date.now() > VISIBLE_UNTIL) return null

  return (
    <StyledAlert
      type={'info'}
      showIcon
      message={<FormattedMessage id={'help.notice.title'} />}
      description={<FormattedMessage id={'help.notice.body'} />}
    />
  )
}
export default ReleaseNotice
